module.exports = __webpack_public_path__ + "img/HT01082-01.8c6d4d91.jpg";